var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"mx-1",attrs:{"tile":"","width":_vm.$attrs.width ? _vm.$attrs.width : 100},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }